import React from "react";
import { connect } from "react-redux";
import BaselineTableRow from "./BaselineTableRow";
import { useBaselineTableHelper } from "./useBaselineTableHelper";
import { debug } from "../../utils";
import { CheckboxTable } from "../../view/CheckboxTable";


function BaselineTable({ baselineRules = [] }) {

    const baselineTableHelper = useBaselineTableHelper();

    const headers = [
        { name: 'RULE NAME', onClick: () => baselineTableHelper.onHostClick() },
        { name: 'HAS BASELINE SCRIPT', onClick: () => baselineTableHelper.onStatusClick() },
        { name: 'SEVERITY', onClick: () => baselineTableHelper.onStatusClick() },
        { name: 'STATUS', onClick: () => baselineTableHelper.onStatusClick() },
    ]

    return (
        <CheckboxTable headers={headers} elements={baselineRules}>
            {baselineRules.map((baselineRule, index) => <BaselineTableRow key={index} data={baselineRule} index={index} />)}
        </CheckboxTable>
    );
}

function mapStateToProps(state) {
    debug("BaselineTable mapStateToProps", state);
    const baselinePage = state.baselinePage;
    return {
        baselineRules: baselinePage.baselineRules || []
    };
}

export default connect(mapStateToProps)(BaselineTable);
